import React from "react";

interface CustomSVGProps extends React.SVGProps<SVGSVGElement> {}

const PlusSVG: React.FC<CustomSVGProps> = (props) => {
	return (
		<svg
			{...props}
			height="14"
			viewBox="0 0 35 35"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g>
				<path d="m33.5 14c0-.3999-.1499-.7798-.4297-1.0598-.29-.28-.6704-.4402-1.0703-.4402l-9.5.0103v-9.5103c0-.3899-.1499-.7798-.4297-1.0598-.29-.28-.6704-.4402-1.0703-.4402l-6.9902.0103c-.8296 0-1.5.6699-1.5 1.5v9.4897h-9.5098c-.3901 0-.77.1602-1.0601.4402-.2797.28-.4399.6599-.4399 1.0598v7.0103c0 .8298.6802 1.5 1.5 1.5h9.5098l-.0098 9.4897c0 .4001.1602.7803.4399 1.0601.2803.29.6602.4399 1.0601.4399h7c.8301 0 1.5-.6699 1.5-1.5v-9.5h9.5c.8301 0 1.5-.6699 1.5-1.5z" />
			</g>
		</svg>
	);
};

export default PlusSVG;
